import React from 'react';
import ItemList from './ItemList'; // Certifique-se de que ItemList.js está no mesmo diretório ou ajuste o caminho

function Report() {
  return (
    <section>
      {/* Aqui você pode adicionar outros elementos específicos do seu Report, se houver */}
      <h1>Relatório Tanque Cheio</h1>
      {/* O componente ItemList é renderizado aqui */}
      <ItemList />
      {/* Mais conteúdo do relatório pode vir depois da lista */}
    </section>
  );
}

export default Report;
